// Libs
import React from 'react';
// Components
import { LogoIcon } from 'components';
import styles from './ImportReview.module.css';

const HeaderPreview = ({
	onContinue,
	onCancel,
	orderCount = 0,
	blockingCount = 0,
	autoCorrectedCount = 0,
	zoneCoverageChangeCount = 0,
	zoneCreationCount = 0,
	zoneCreationAffectedOrderCount = 0,
	contractFrequencyCreationCount = 0,
	contractFrequencyCreationAffectedOrderCount = 0,
	assignmentConfirmationRequired = false,
	needsRevalidation = false,
	isValidating = false,
	isSubmitting = false,
	isInteractionBlocked = false,
	onValidate,
	themeStyle,
	themeProfile,
}) => {
	const isBlocked = blockingCount > 0 || needsRevalidation;
	const importableLabel = `${orderCount} ${
		orderCount === 1 ? 'orden importable' : 'órdenes importables'
	}`;
	const importSummary = autoCorrectedCount
		? `${importableLabel} · ${autoCorrectedCount} ${
				autoCorrectedCount === 1 ? 'auto-corregida' : 'auto-corregidas'
			}`
		: importableLabel;
	const mutationSummary = [];
	const confirmationTargets = [];
	if (assignmentConfirmationRequired) {
		mutationSummary.push('cambio de asignación');
		confirmationTargets.push('asignación');
	}
	if (zoneCoverageChangeCount > 0) {
		mutationSummary.push(
			`${zoneCoverageChangeCount} ${
				zoneCoverageChangeCount === 1
					? 'aprovisionamiento de cobertura'
					: 'aprovisionamientos de cobertura'
			} se aplicarán al confirmar`,
		);
		confirmationTargets.push('cobertura');
	}
	if (zoneCreationCount > 0) {
		mutationSummary.push(
			`${zoneCreationCount} ${
				zoneCreationCount === 1 ? 'zona nueva' : 'zonas nuevas'
			} para ${zoneCreationAffectedOrderCount} ${
				zoneCreationAffectedOrderCount === 1 ? 'orden' : 'órdenes'
			}`,
		);
		confirmationTargets.push('zonas');
	}
	if (contractFrequencyCreationCount > 0) {
		mutationSummary.push(
			`${contractFrequencyCreationCount} ${
				contractFrequencyCreationCount === 1
					? 'frecuencia contractual nueva'
					: 'frecuencias contractuales nuevas'
			} para ${contractFrequencyCreationAffectedOrderCount} ${
				contractFrequencyCreationAffectedOrderCount === 1 ? 'orden' : 'órdenes'
			}`,
		);
		confirmationTargets.push('frecuencias contractuales');
	}
	const changeSummary = [importSummary, ...mutationSummary].join(' · ');
	const confirmationTargetLabel = confirmationTargets.length
		? confirmationTargets.length === 1
			? confirmationTargets[0]
			: `${confirmationTargets.slice(0, -1).join(', ')} y ${
					confirmationTargets[confirmationTargets.length - 1]
				}`
		: undefined;
	const continueLabel = confirmationTargetLabel
		? `Confirmar ${confirmationTargetLabel} e importar`
		: 'Importar';

	return (
		<div className={styles.header} style={themeStyle} data-theme={themeProfile}>
			<div>
				<h2 className={styles.headerTitle}>Revisión de importación</h2>
				<span className={styles.headerMeta} aria-live='polite'>
					{needsRevalidation
						? 'Hay cambios sin validar. Valídalos antes de importar.'
						: isBlocked
							? `${blockingCount} ${
									blockingCount === 1 ? 'orden bloqueada' : 'órdenes bloqueadas'
								} requieren corrección`
							: changeSummary}
				</span>
			</div>
			<div className={styles.headerActions}>
				{needsRevalidation && (
					<button
						type='button'
						className={`${styles.headerButton} ${styles.headerButtonSecondary}`}
						onClick={onValidate}
						disabled={isSubmitting || isValidating || isInteractionBlocked}
					>
						{isValidating ? 'Validando...' : 'Validar cambios'}
					</button>
				)}
				<button
					type='button'
					className={`${styles.headerButton} ${styles.headerButtonSecondary}`}
					onClick={onCancel}
					disabled={isSubmitting || isValidating || isInteractionBlocked}
				>
					Cancelar
				</button>
				{isSubmitting ? (
					<span className={styles.headerLoading} role='status'>
						Importando...
						<LogoIcon spin={true} />
					</span>
				) : (
					<button
						type='button'
						className={`${styles.headerButton} ${styles.headerButtonPrimary}`}
						onClick={onContinue}
						disabled={
							isSubmitting ||
							isBlocked ||
							isValidating ||
							isInteractionBlocked ||
							orderCount === 0
						}
						title={
							isInteractionBlocked
								? 'Confirma o cancela la acción masiva antes de continuar'
								: needsRevalidation
									? 'Valida los cambios para actualizar las incidencias'
									: isBlocked
										? 'Corrige las incidencias bloqueantes antes de importar'
										: undefined
						}
					>
						{continueLabel} {orderCount}
					</button>
				)}
			</div>
		</div>
	);
};

export default HeaderPreview;
